import { ShopAddressResponse } from "../redux/actions/collectOrders";
import { IGooglePlaceResponse } from "./googlePlacesUtil";
export interface ITimeSlot {
  Start: string;
  FlexibleCutoffThreshold: number;
}

export interface ISlot {
  value: Date | string;
  label: string;
}

export interface IAvailableSlots {
  day: Date | string;
  availableSlots: Array<ISlot>;
}

export const DEFAULT_VALIDATION_MSG = "This field is mandatory.";
export const REF_NUMBER_LENGTH = 36;
export const ADDRESS_CHANGED_PATTERN = /(?<=\bto\b).*?(?=\.)/;
export const ADDRESS_CHANGED_ISSUES = [
  "pickup_location_changed",
  "dropoff_location_changed",
];
export const ADDRESS_CHANGED_SHOULD_WAIT = ["pending", "looking_for_driver"];
export const ORKESTRO_ERROR = {
  Price: "Something has gone wrong while getting the price, please try again.",
  PlaceOrder:
    "Something has gone wrong while placing the order, please try again.",
};
export enum CollectionOrderError {
  NoFleetFoundForGivenVehicleType = "NoFleetFoundForGivenVehicleType",
}

export const mapShopAddressToInputs = (res: ShopAddressResponse) => ({
  Name: res.Name,
  Line1: res.AddressLine1,
  Line2: res.AddressLine2,
  Line3: res.AddressLine3,
  PostCode: res.PostCode,
  City: res.City,
  StateOrProvince: res.County,
  Lat: res.Lat,
  Long: res.Long,
  Line1Short: "",
  StreetNumber: "",
  Vicinity: "",
  Premise: "",
});

export const getAddressStringFromErrorMsg = (err: string) => {
  let address;

  const matches = err.match(ADDRESS_CHANGED_PATTERN);
  if (matches && matches.length > 0) {
    address = matches[0].trim();
  }

  return address;
};

export const hasValidAddress = (address: IGooglePlaceResponse) => {
  return Boolean(
    address &&
    address.Line1 &&
    address.Line1.length > 0 &&
    address.PostCode &&
    address.PostCode.length > 0 &&
    address.StateOrProvince &&
    address.StateOrProvince.length > 0 &&
    address.Lat &&
    address.Lat !== 0 &&
    address.Long &&
    address.Long !== 0
  );
};
